import { getLocalTodayDate } from 'src/utils/getLocalTodayDate';
import { VIEWS_STATUSES_LIST } from 'src/constants/statuses';

export const INITIAL_FILTERS_STATE = {
  date_from: '2018-01-01',
  date_to: getLocalTodayDate(),
  email: '',
  id: '',
  status: '',
  plan: '',
  domain: '',
  promo_code: '',
  messenger: '',
  sort_by: 'last_login',
  order: 'desc',
};

export const FIELDS = [
  {
    type: 'textField',
    label: 'Email',
    name: 'email',
    placeholder: 'Email',
    className: 'main',
  },
  {
    type: 'textField',
    label: 'ID',
    name: 'id',
    placeholder: 'ID',
    className: 'main',
  },
  {
    type: 'select',
    label: 'Status',
    name: 'status',
    placeholder: 'Status',
    options: VIEWS_STATUSES_LIST,
    className: 'basic',
  },
  {
    type: 'select',
    label: 'Plan',
    name: 'plan',
    placeholder: 'Plan',
    options: [],
    className: 'basic',
  },
  {
    type: 'textField',
    label: 'Dedicated domain',
    name: 'domain',
    placeholder: 'Dedicated domain',
    className: 'basic',
  },
  {
    type: 'textField',
    label: 'Promo',
    name: 'promo_code',
    placeholder: 'Promo',
    className: 'basic',
  },
  {
    type: 'textField',
    label: 'Messenger',
    name: 'messenger',
    placeholder: 'Messenger',
    className: 'basic',
  },
  {
    type: 'date',
    label: 'Date from',
    name: 'date_from',
    className: 'date',
  },
  {
    type: 'date',
    label: 'Date to',
    name: 'date_to',
    className: 'date',
  },
];
